// CalendarTimelineContext.js

import React, { createContext, useContext, useMemo, useState } from 'react';

const CalendarTimelineContext = createContext(null);

export const CalendarTimelineProvider = ({
  children,
  initialCalendarViewType = 'MONTH',
  initialTimelineViewType = 'WEEK',
  initialSelectedDate = null,
}) => {
  const [selectedDate, setSelectedDate] = useState(() => {
    if (initialSelectedDate instanceof Date && !Number.isNaN(initialSelectedDate.getTime())) {
      return initialSelectedDate;
    }
    return new Date();
  });
  const [calendarViewType, setCalendarViewType] = useState(
    String(initialCalendarViewType || 'MONTH').toUpperCase(),
  );
  const [timelineViewType, setTimelineViewType] = useState(
    String(initialTimelineViewType || 'WEEK').toUpperCase(),
  );

  const value = useMemo(() => ({
    selectedDate,
    setSelectedDate,
    calendarViewType,
    setCalendarViewType,
    timelineViewType,
    setTimelineViewType,
  }), [selectedDate, calendarViewType, timelineViewType]);

  return (
    <CalendarTimelineContext.Provider value={value}>
      {children}
    </CalendarTimelineContext.Provider>
  );
};

export const useCalendarTimeline = () => {
  const context = useContext(CalendarTimelineContext);
  if (!context) {
    throw new Error('useCalendarTimeline must be used within CalendarTimelineProvider');
  }
  return context;
};

export default CalendarTimelineContext;
